var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagonalArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03587 0.539062C8.25689 0.539062 8.46885 0.62686 8.62513 0.78314C8.78141 0.939421 8.86921 1.15138 8.86921 1.3724V7.26573C8.86921 7.48674 8.78141 7.6987 8.62513 7.85498C8.46885 8.01127 8.25689 8.09906 8.03587 8.09906C7.81486 8.09906 7.6029 8.01127 7.44662 7.85498C7.29034 7.6987 7.20254 7.48674 7.20254 7.26573V3.3849L1.55337 9.03323C1.3962 9.18503 1.1857 9.26902 0.967206 9.26712C0.748708 9.26523 0.539698 9.17758 0.385191 9.02308C0.230684 8.86857 0.143043 8.65956 0.141145 8.44106C0.139246 8.22257 0.223242 8.01206 0.37504 7.8549L6.02337 2.20573H2.14337C1.92236 2.20573 1.7104 2.11793 1.55412 1.96165C1.39784 1.80537 1.31004 1.59341 1.31004 1.3724C1.31004 1.15138 1.39784 0.939421 1.55412 0.78314C1.7104 0.62686 1.92236 0.539062 2.14337 0.539062H8.03587Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagonalArrow);
export default __webpack_public_path__ + "static/media/diagonalArrow.60dd63fcd21c1ba9e0d0af06a050254f.svg";
export { ForwardRef as ReactComponent };